export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content",
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "solution/list",
            name: "solutionList",
            component: resolve => require(["@/modules/solution/pages/list.vue"], resolve)
          },
          {
            path: "solution/edit/:id",
            name: "solutionEdit",
            component: resolve => require(["@/modules/solution/pages/edit.vue"], resolve)
          },
          {
            path: "solution/type",
            name: "solutionType",
            component: resolve => require(["@/modules/solution/pages/type.vue"], resolve)
          },
          {
            path: "solution/banner",
            name: "solutionBanner", //方案专题
            component: resolve => require(["@/modules/solution/pages/banner.vue"], resolve)
          },
          {
            path: "solution/subject",
            name: "solutionSubject", //编辑专题
            component: resolve => require(["@/modules/solution/pages/subject.vue"], resolve)
          },
          {
            path: "solution/listall",
            name: "solutionListAll", //方案池
            component: resolve => require(["@/modules/solution/pages/listall.vue"], resolve)
          }
        ]
      }
    ]
  }
];
